export const VLM_MAX_IMAGE_SIZE_MB = 10;
export const VLM_MAX_IMAGE_SIZE_BYTES = VLM_MAX_IMAGE_SIZE_MB * 1024 * 1024;
// The worker's MAX_VIDEO_MB: a PRO video goes up whole and is read by the worker itself.
export const VLM_MAX_VIDEO_SIZE_MB = 2048;

const isVideo = image =>
  String(image?.type ?? image?.file?.type ?? '').startsWith('video/');

export function spatialVisionImageSize(image) {
  const size = image?.size ?? image?.file?.size ?? image?.fileSize;
  const numericSize = Number(size);
  return Number.isFinite(numericSize) && numericSize >= 0 ? numericSize : null;
}

export function isVlmImageOversized(image) {
  const size = spatialVisionImageSize(image);
  const limitMb = isVideo(image)
    ? VLM_MAX_VIDEO_SIZE_MB
    : VLM_MAX_IMAGE_SIZE_MB;
  return size !== null && size > limitMb * 1024 * 1024;
}

export function partitionVlmImages(images = []) {
  return Array.from(images).reduce(
    (result, image) => {
      result[isVlmImageOversized(image) ? 'rejected' : 'accepted'].push(image);
      return result;
    },
    { accepted: [], rejected: [] },
  );
}

export function oversizedVlmImageNotice(images, keptCount = 0) {
  const rejected = Array.from(images || []);
  const count = rejected.length;
  const labels = rejected.slice(0, 3).map(image => {
    const name =
      image?.name ||
      image?.originalName ||
      image?.file?.name ||
      'Unnamed image';
    const size = spatialVisionImageSize(image);
    if (size === null) return name;
    const roundedUpMb = Math.ceil((size / (1024 * 1024)) * 10) / 10;
    return `${name} (${roundedUpMb.toFixed(1)} MB)`;
  });
  const remaining = count - labels.length;
  const fileList = `${labels.join(', ')}${
    remaining > 0 ? `, and ${remaining} more` : ''
  }`;
  return {
    title: `${count} image${count === 1 ? '' : 's'} skipped`,
    description: `${fileList} ${
      count === 1 ? 'is' : 'are'
    } over O-HIVE VLM's ${VLM_MAX_IMAGE_SIZE_MB} MB per-image${
      rejected.some(isVideo) ? ` or ${VLM_MAX_VIDEO_SIZE_MB} MB per-video` : ''
    } limit. ${
      keptCount > 0
        ? 'Your other selected images were kept.'
        : 'Choose a smaller image to continue.'
    }`,
  };
}
